import { CHAT_CLUSTER, CHAT_KEY } from 'config'
import Pusher from 'pusher-js'

export const ChatMsgPusher = new Pusher(CHAT_KEY || '', {
 cluster: CHAT_CLUSTER || '',
})
